'use strict';

(() => {
    const ProductQuickAdd = class extends HTMLElement {
        #scopeFromPassed = false;
        #scopeToReached = false;
        #variantPickerVisible = false;
        #buyButtonsVisible = false;
        #relatedProductsVisible = false;
        #hasScrolledPastRelated = false;
        #intersectionObserver = new IntersectionObserver(this._onObserved.bind(this));

        connectedCallback() {
            this._scopeFrom = document.getElementById(this.getAttribute('form'));
            this._scopeTo = document.querySelector('.footer');
            this._variantPicker = document.querySelector('.product-info__block-item[data-block-id="variant_picker"]');
            this._buyButtons = document.querySelector('.product-info__block-item[data-block-id="buy_buttons"]');
            this._relatedProducts = document.querySelector('section.bs-related-products');

            if (!this._scopeFrom || !this._scopeTo || !this._variantPicker || !this._buyButtons || !this._relatedProducts) {
                return;
            }

            this.#intersectionObserver.observe(this._scopeFrom);
            this.#intersectionObserver.observe(this._scopeTo);
            this.#intersectionObserver.observe(this._variantPicker);
            this.#intersectionObserver.observe(this._buyButtons);
            this.#intersectionObserver.observe(this._relatedProducts);

            this._updateVisibility();

            const buttonForm = this.querySelector('button[type="submit"]');
            buttonForm.addEventListener('click', (e) => this._handleButtonClick(e));
        }

        disconnectedCallback() {
            this.#intersectionObserver.disconnect();
        }

        _onObserved(entries) {
            entries.forEach((entry) => {
                if (entry.target === this._scopeFrom) {
                    this.#scopeFromPassed = entry.boundingClientRect.bottom < 0;
                }
                if (entry.target === this._scopeTo) {
                    this.#scopeToReached = entry.isIntersecting;
                }
                if (entry.target === this._variantPicker) {
                    this.#variantPickerVisible = entry.isIntersecting;
                }
                if (entry.target === this._buyButtons) {
                    this.#buyButtonsVisible = entry.isIntersecting;
                }
                if (entry.target === this._relatedProducts) {
                    this.#relatedProductsVisible = entry.isIntersecting;
                    if (this.#relatedProductsVisible) {
                        this.#hasScrolledPastRelated = true;
                    }
                }
            });

            if (!this.#relatedProductsVisible) {
                this.#hasScrolledPastRelated = false;
            }

            this._updateVisibility();
        }

        _updateVisibility() {
            const shouldBeVisible =
                (!this.#scopeFromPassed || this.#scopeFromPassed) &&
                !this.#scopeToReached &&
                !this.#variantPickerVisible &&
                !this.#buyButtonsVisible &&
                !this.#relatedProductsVisible &&
                !this.#hasScrolledPastRelated;

            this.classList.toggle('is-visible', shouldBeVisible);
        }

        _handleButtonClick(e) {
            if (variantsArray.length > 1) {
                e.preventDefault();
                this._variantPicker.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    };

    if (!window.customElements.get('product-quick-add')) {
        window.customElements.define('product-quick-add', ProductQuickAdd);
    }
})();